import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../pages/Home.vue'
import MyDepartment from '../pages/MyDepartment.vue'
import HrInfo from '../pages/HrInfo.vue'
import Organization from '../pages/Organization.vue'
import Resources from '../pages/Resources.vue'
import Login from '../pages/Login.vue'
import PostDetail from '../pages/PostDetail.vue'
import { safeFetch } from './fetch'
//import { safeFetch } from './fetch'

const routes = [
  { path: '/', component: Home, meta: { requiresAuth: true } },
  { path: '/my-department', component: MyDepartment, meta: { requiresAuth: true } },
  { path: '/hr-info', component: HrInfo, meta: { requiresAuth: true } },
  { path: '/organization', component: Organization, meta: { requiresAuth: true } },
  { path: '/resources', component: Resources, meta: { requiresAuth: true } },
  { path: '/login', component: Login },
  { path: '/:type(post|announcement|event|goal|process|training)/:slug', component: PostDetail, meta: { requiresAuth: true } }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

router.beforeEach(async (to, from, next) => {
  const isLoggedIn = !!localStorage.getItem('authToken');
  if (to.meta.requiresAuth) {
    if (!isLoggedIn) {
      next('/login');
      return;
    }
    // Validate token with backend
    try {
      const token = localStorage.getItem('authToken');
      const response = await safeFetch(`/wp-json/wp/v2/users/me`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) {
        localStorage.removeItem('authToken');
        next('/login');
        return;
      }
    } catch {
      localStorage.removeItem('authToken');
      next('/login');
      return;
    }
  }
  if (to.path === '/login' && isLoggedIn) {
    next('/');
  } else {
    next();
  }
});

export default router